var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#454ADE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 10.7503V13.5003H2.50008V10.7503H0.666748V13.5003C0.666748 14.5087 1.49175 15.3337 2.50008 15.3337H13.5001C14.5084 15.3337 15.3334 14.5087 15.3334 13.5003V10.7503H13.5001ZM12.5834 7.08366L11.2909 5.79116L8.91675 8.15616V0.666992H7.08341V8.15616L4.70925 5.79116L3.41675 7.08366L8.00008 11.667L12.5834 7.08366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/downloadFile.8534d469.svg";
export { ForwardRef as ReactComponent };